import CpfVerification from 'components/paciente/CpfVerification';
import React, { useState } from 'react';
import AgendamentoOnline from './AgendamentoOnline';

export default function AgendamentoOnlineFlow() {
  const [patientInfo, setPatientInfo] = useState(null);

  const handleSuccess = (data) => {
    setPatientInfo(data);
  };

  return patientInfo ? (
    <AgendamentoOnline patientInfo={patientInfo} />
  ) : (
    <CpfVerification onSuccess={handleSuccess} />
  );
}
